    // import { configureStore } from "@reduxjs/toolkit";
    // import userReducer from "./slice/userData"
    // import roleReducer from "./slice/getRoleData"
    // import subLeaveTypeReducer from "./slice/subLeaveType";
    // import LeaveTypeReducer from "./slice/leaveType";
    // import leaveDurationReducer from "./slice/leaveDuration";
    // import leaveSummaryReducer from "./slice/getLeaveSummary";
    // import holidayReducer from "./slice/getHolidayData";
    // import leaveReducer from "./slice/getLeavesData";
    // import allUserReducer from "./slice/getAllUserData"
    // import authReducer from "./slice/authSlice";
    // export const store = configureStore({
    //     reducer:{
    // userData:userReducer,
    // getAllUserData:allUserReducer,
    // getRoleData:roleReducer,
    // getSubLeaveType:subLeaveTypeReducer,
    // getLeaveType:LeaveTypeReducer,
    // getLeaveDuration:leaveDurationReducer,
    // getLeaveSummary:leaveSummaryReducer,
    // getHoliday:holidayReducer,
    // getLeaveData:leaveReducer,
    // auth: authReducer,
    //     }
    // })

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // default localStorage for web
import userReducer from "./slice/userData";
import roleReducer from "./slice/getRoleData";
import subLeaveTypeReducer from "./slice/subLeaveType";
import LeaveTypeReducer from "./slice/leaveType";
import leaveDurationReducer from "./slice/leaveDuration";
import leaveSummaryReducer from "./slice/getLeaveSummary";
import holidayReducer from "./slice/getHolidayData";
import leaveReducer from "./slice/getLeavesData";
import allUserReducer from "./slice/getAllUserData";
import authReducer from "./slice/authSlice";

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'] // only auth will be persisted
};

const rootReducer = {
    userData: userReducer,
    getAllUserData: allUserReducer,
    getRoleData: roleReducer,
    getSubLeaveType: subLeaveTypeReducer,
    getLeaveType: LeaveTypeReducer,
    getLeaveDuration: leaveDurationReducer,
    getLeaveSummary: leaveSummaryReducer,
    getHoliday: holidayReducer,
    getLeaveData: leaveReducer,
    auth: authReducer,
};

const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer));

export const store = configureStore({
    reducer: persistedReducer
});

export const persistor = persistStore(store);
